import { ButtonWithConfirmation } from 'framework/ui/ui-builder';
import { ARCHIVE_DAVINCI_OBJECT, useProjectId, useProjectService } from 'domain/shared/project';
import { useShowContext } from 'framework/show';

const ArchiveObjects = () => {
  const { data } = useShowContext();
  const defaultBudgetId = data.getValueBySource('defaultBudgetId') || undefined;
  const isArchived = data.getValueBySource('archived');
  const { archiveObjects } = useProjectService();
  const id = useProjectId();

  if (isArchived) {
    return null;
  }

  return (
    <ButtonWithConfirmation
      afterSubmit={{
        successMessage: 'Project archived successfully.',
        errorMessage: `Can't archive project.`,
      }}
      submitMethod={() => archiveObjects(id, defaultBudgetId)}
      permissionToCheck={ARCHIVE_DAVINCI_OBJECT}
      displayMessage="Do you really want to archive this project?"
      variant="outlined"
    >
      Archive
    </ButtonWithConfirmation>
  );
};

export default ArchiveObjects;
